import { useMemo, type ReactNode } from 'react';
import type { SelectedNetwork } from '@/types';
import { aggregateShows } from '@/utils';
import { DerivedNetworkContext } from './useDerivedNetworkContext';

interface DerivedNetworkProviderProps {
  children: ReactNode;
  selectedNetwork: SelectedNetwork;
  /**
   * All selected networks. In path mode pass `[selectedNetwork]`; in query mode pass the full list
   * resolved from `?networks=`.
   */
  selectedNetworks: SelectedNetwork[];
}

const DerivedNetworkProvider = ({
  children,
  selectedNetwork,
  selectedNetworks,
}: DerivedNetworkProviderProps) => {
  const shows = useMemo(() => aggregateShows(selectedNetworks), [selectedNetworks]);

  return (
    <DerivedNetworkContext.Provider value={{ selectedNetwork, selectedNetworks, shows }}>
      {children}
    </DerivedNetworkContext.Provider>
  );
};

export default DerivedNetworkProvider;
